export default function ConfirmDialog({ open, title = 'Confirm', message, confirmLabel = 'Delete', danger = true, busy = false, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="sb-backdrop" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }} onClick={onCancel}>
      <div className="card" style={{ width: 420, maxWidth: '92vw' }} onClick={(e) => e.stopPropagation()}>
        <div className="ct">{title}</div>
        <div style={{ color: 'var(--ink-s)', fontSize: 'var(--text-base)', lineHeight: 1.6, marginBottom: '1.3rem' }}>{message}</div>
        <div style={{ display: 'flex', gap: '.6rem', justifyContent: 'flex-end' }}>
          <button type="button" className="btn btn-ghost" onClick={onCancel} disabled={busy}>
            <i className="fa-solid fa-xmark" /> Cancel
          </button>
          <button type="button" className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirm} disabled={busy}>
            <i className={`fa-solid ${busy ? 'fa-spinner fa-spin' : danger ? 'fa-trash-can' : 'fa-check'}`} />
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
